import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  scanner: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/scanner.vue").then(m => m.default || m))
}